export interface PlotSection {
  id: string;
  heading: string;
  paragraphs: string[];
}

export interface Plot {
  id: string;
  title: string;
  date: string;
  excerpt: string;
  thumbnail: string;
  tags: string[];
  author: string;
  readTime: string;
  sections: PlotSection[];
}

export const plots: Plot[] = [
  {
    id: "plot-1",
    title: "《年轻的母亲1》林晓与婆婆的第一场正面交锋",
    date: "2025-08-16",
    excerpt: "一锅没喝完的鲫鱼汤，为什么能引爆三代人的情绪？从第四集那场厨房对峙看家庭矛盾的真正内核。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20tense%20kitchen%20scene%20with%20two%20Chinese%20women%20facing%20each%20other%2C%20a%20bowl%20of%20soup%20on%20the%20counter%2C%20soft%20overcast%20light%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20restrained%20emotional%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-plot-thumb-01&orientation=landscape",
    tags: ["家庭矛盾", "人物解析"],
    author: "剧评小组",
    readTime: "6 分钟",
    sections: [
      {
        id: "background",
        heading: "那口锅背后的三十年",
        paragraphs: [
          "第四集的厨房对峙，被许多观众称为全剧第一个情绪高点。表面上看，冲突源于一锅没喝完的鲫鱼汤；但真正让两人站到对立面的，是两代女性对‘母亲’这个身份完全不同的理解。",
          "张桂兰相信，牺牲是母爱的证明。她把自己半生的隐忍当成经验，试图原样传给儿媳。而林晓接受的教育告诉她，母亲首先是一个人，然后才是母亲。这不是谁对谁错，而是两条被时代塑造的轨道，第一次被迫相交。",
        ],
      },
      {
        id: "turning",
        heading: "陈默的缺席才是一切的关键",
        paragraphs: [
          "值得注意的是，在这场对峙中，陈默始终没有在场。他的缺席，让两个女人不得不在没有任何缓冲的情况下直接碰撞。导演用大量封闭的构图强调这种‘被困住’的感觉。",
          "直到第四集结尾，陈默才第一次公开站在林晓一边。这个迟到的表态并不完美，却成为了整部剧关系转折的起点。",
        ],
      },
      {
        id: "meaning",
        heading: "一场争论，两种母亲",
        paragraphs: [
          "这场戏真正高明的地方，在于它没有把任何一方写成反派。镜头给到张桂兰转身时的背影，也给到林晓颤抖的手。它让观众同时看到了伤害与被伤害的来源，这也是《年轻的母亲1》区别于普通家庭剧之处。",
        ],
      },
    ],
  },
  {
    id: "plot-2",
    title: "深度解析：林晓重返职场背后的女性困境",
    date: "2025-08-18",
    excerpt: "从母婴室的眼泪到被接手的项目，第三集用冷静的镜头，讲了一个很多职场妈妈都懂的沉默故事。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20woman%20standing%20alone%20in%20a%20glass%20office%20corridor%20looking%20out%2C%20cool%20daylight%20and%20reflections%2C%20muted%20teal%20with%20warm%20orange%20accents%2C%20lonely%20reflective%20mood%2C%20editorial%20cinematography%2C%20high%20detail%2C%20clean%20neutral%20background&width=800&height=450&seq=nm1-plot-thumb-02&orientation=landscape",
    tags: ["女性成长", "人物解析"],
    author: "剧评小组",
    readTime: "7 分钟",
    sections: [
      {
        id: "return",
        heading: "回归的第一天，位置已经不在",
        paragraphs: [
          "第三集几乎没有激烈的争吵，却让无数观众感到窒息。林晓回到公司的第一天，发现曾经由她主导的项目已经换了负责人，同事的问候礼貌而疏远。",
          "编剧没有安排任何戏剧化的排挤，只是让一切‘悄无声息地发生’。这种职场对女性的隐形挤出，恰恰比明面上的不公更令人无力。",
        ],
      },
      {
        id: "pump",
        heading: "母婴室里的十分钟",
        paragraphs: [
          "全集最打动人的镜头，是林晓在母婴室里一边挤奶一边回复工作消息。狭小的空间、窗外模糊的人影、屏幕上跳出的一条条进度提醒——这十分钟里，她既是员工也是母亲，却哪一边都做不完整。",
        ],
      },
      {
        id: "support",
        heading: "苏雅的出现意味着什么",
        paragraphs: [
          "正是在这一集，闺蜜苏雅重新进入了林晓的生活。她的意义不只是情感陪伴，更代表了一种‘另一种可能’——女性可以不按既定剧本生活。这条线索为后续林晓辞职、重启设计梦想埋下伏笔。",
        ],
      },
    ],
  },
  {
    id: "plot-3",
    title: "陈默是‘渣’还是‘普通’？谈谈这个被骂最多的角色",
    date: "2025-08-20",
    excerpt: "他既没有背叛，也没有担当。为什么这个不太讨喜的丈夫，反而让很多人看到了身边的影子？",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20man%20sitting%20tired%20on%20a%20sofa%20late%20at%20night%20in%20a%20dim%20apartment%2C%20phone%20glow%20on%20his%20face%2C%20cool%20blue%20shadow%20with%20a%20single%20warm%20lamp%2C%20conflicted%20quiet%20mood%2C%20editorial%20cinematography%2C%20high%20detail%2C%20dark%20neutral%20background&width=800&height=450&seq=nm1-plot-thumb-03&orientation=landscape",
    tags: ["人物解析", "感情线"],
    author: "剧评小组",
    readTime: "6 分钟",
    sections: [
      {
        id: "hate",
        heading: "为什么观众这么想骂他",
        paragraphs: [
          "陈默大概是《年轻的母亲1》里被讨论最多的角色。他不家暴、不出轨，甚至偶尔也很体贴，但他总是在最需要他的时刻‘不在场’。",
          "观众对他的愤怒，其实来自一种熟悉感——现实里太多伴侣就是这样，不算坏，却也没真正长大。",
        ],
      },
      {
        id: "grow",
        heading: "笨拙地学着成长",
        paragraphs: [
          "从第九集开始，陈默终于做出改变。他学着做饭、争取更灵活的岗位，虽然动作总是慢半拍。编剧没有给他一个突然开悟的爽点，而是让改变一点点发生。",
          "这种‘不完美的成长’，恰恰是这部剧最真实的地方。",
        ],
      },
    ],
  },
  {
    id: "plot-4",
    title: "沉默的父亲：王强这个角色存在的意义",
    date: "2025-08-22",
    excerpt: "他几乎不参与争吵，却用一次深夜来访，讲清了一个家庭里‘沉默的爱’是如何被误读的。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20middle%20aged%20Chinese%20man%20standing%20at%20a%20doorway%20holding%20an%20old%20suitcase%20at%20night%2C%20warm%20hallway%20light%20behind%20him%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20quiet%20restrained%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20dark%20neutral%20background&width=800&height=450&seq=nm1-plot-thumb-04&orientation=landscape",
    tags: ["人物解析", "家庭矛盾"],
    author: "剧评小组",
    readTime: "5 分钟",
    sections: [
      {
        id: "silent",
        heading: "家里的第二个沉默者",
        paragraphs: [
          "如果说陈默是那个‘不会说话’的丈夫，王强就是那个‘从不愿意说话’的父亲。他在整部剧里的台词屈指可数，却总在关键时刻出现。",
        ],
      },
      {
        id: "suitcase",
        heading: "那只旧行李箱",
        paragraphs: [
          "第九集里，王强拎着一只旧行李箱站在儿子家门口，什么都没说，只是把钥匙放下。这一幕解释了陈默性格里的笨拙温柔从何而来——爱从来不是用一个家庭的语言说出来的。",
        ],
      },
    ],
  },
  {
    id: "plot-5",
    title: "从厨房到书桌：《年轻的母亲1》里的女性成长线梳理",
    date: "2025-08-24",
    excerpt: "全剧最动人的不是和解，而是一个女人如何重新找回自己的名字。完整梳理林晓的成长轨迹。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20woman%20sketching%20designs%20at%20a%20sunlit%20desk%20with%20draft%20papers%20and%20coffee%2C%20bright%20morning%20window%20light%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20hopeful%20focused%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-plot-thumb-05&orientation=landscape",
    tags: ["女性成长", "感情线"],
    author: "剧评小组",
    readTime: "8 分钟",
    sections: [
      {
        id: "stage1",
        heading: "第一阶段：被定义的母亲",
        paragraphs: [
          "前六集的林晓，始终活在别人的期待里——婆婆眼中合格的儿媳，丈夫眼中体贴的妻子，公司里不掉链子的员工。她的情绪从未被真正看见。",
        ],
      },
      {
        id: "stage2",
        heading: "第二阶段：裂缝中的觉醒",
        paragraphs: [
          "第六集的深夜急诊，是她转变的分水岭。当一个人独自面对孩子的病痛与丈夫的失联，她不再指望被拯救，而是决定自己站起来。",
        ],
      },
      {
        id: "stage3",
        heading: "第三阶段：重新拿回名字",
        paragraphs: [
          "辞职、重拾设计、独立接单——林晓一步步把‘我是谁’这个问题重新捡了回来。到最后一集，她依然是一个年轻母亲，但她首先是她自己。",
        ],
      },
    ],
  },
  {
    id: "plot-6",
    title: "结局解读：不是圆满，而是和解",
    date: "2025-08-28",
    excerpt: "第十二集没有给出童话式的结局。婆婆回了老家却常常打来电话——这种‘留白’，才是真正的成熟。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20mother%20and%20her%20daughter%20silhouetted%20against%20a%20bright%20sunrise%20window%2C%20golden%20warm%20light%20flooding%20the%20room%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20hopeful%20bittersweet%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-plot-thumb-06&orientation=landscape",
    tags: ["结局解读", "家庭矛盾"],
    author: "剧评小组",
    readTime: "7 分钟",
    sections: [
      {
        id: "open",
        heading: "为什么结局如此克制",
        paragraphs: [
          "很多观众期待一个‘全家幸福大团圆’的结局，但《年轻的母亲1》选择了另一种收尾。婆婆回了老家，但电话仍然频繁；陈默换了工作，学会做饭，却还是会犯错。",
          "生活没有被解决，只是被继续。这种克制，恰恰是现实主义剧集最珍贵的地方。",
        ],
      },
      {
        id: "light",
        heading: "最后那个逆光的镜头",
        paragraphs: [
          "全剧最后一幕，林晓和女儿站在窗前，阳光涌进来，把母女二人的轮廓勾成剪影。镜头没有给她们的脸，却给了光。",
          "这是一个开放的句子：未来会有新的难题，但这一次，她已经知道如何自己抬头看光。",
        ],
      },
    ],
  },
];

export const plotTags: string[] = ["家庭矛盾", "人物解析", "女性成长", "感情线", "结局解读"];